import { FilmStrip } from "@/components/FilmStrip";
import { Cta } from "@/components/home/Cta";
import { Hero } from "@/components/home/Hero";
import { Innovations } from "@/components/home/Innovations";
import { Manifesto } from "@/components/home/Manifesto";
import { Solutions } from "@/components/home/Solutions";
import { Stats } from "@/components/home/Stats";
import { Works } from "@/components/home/Works";
import { Marquee } from "@/components/Marquee";

export default function HomePage() {
  return (
    <>
      <Hero />
      <Marquee />
      <Manifesto />
      <Solutions />
      <Stats />
      <FilmStrip />
      <Works />
      <Innovations />
      <Cta />
    </>
  );
}
